import { Box, keyframes } from '@arpeggi/ui'
import { ComponentProps, FC, useState } from 'react'

const jumpAnimation = keyframes({
  '0%': {
    WebkitTransform: 'translateY(0)',
    transform: 'translateY(0)'
  },
  '5%': {
    WebkitTransform: 'translateY(0)',
    transform: 'translateY(0)'
  },
  '20%': {
    WebkitTransform: 'translateY(-10px)',
    transform: 'translateY(-10px)'
  },
  '40%': {
    WebkitTransform: 'translateY(0)',
    transform: 'translateY(0)'
  },
  '60%': {
    WebkitTransform: 'translateY(-5px)',
    transform: 'translateY(-5px)'
  },
  '80%': {
    WebkitTransform: 'translateY(0)',
    transform: 'translateY(0)'
  },
  '100%': {
    WebkitTransform: 'translateY(0)',
    transform: 'translateY(0)'
  }
})

export const JumpWrapper: FC<ComponentProps<typeof Box>> = (props) => {
  const [playAnimation, setPlayAnimation] = useState<boolean>(false)
  const animationLengthMS = 1000

  const onHover = () => {
    if (playAnimation) return

    setPlayAnimation(true)
    setTimeout(() => setPlayAnimation(false), animationLengthMS)
  }

  return (
    <Box
      onMouseOver={onHover}
      css={{ animation: playAnimation && `linear ${animationLengthMS}ms ${jumpAnimation}` }}
      {...props}
    >
      {props.children}
    </Box>
  )
}
